import React, { useEffect, useState } from 'react';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import IconButton from '@mui/material/IconButton';
// You will need to export this from your provider file
// export type SnackbarPosition = 'top' | 'bottom'; 
// If you did this, you can import it here.
type SnackbarPosition = 'top' | 'bottom';

export interface SnackbarProps {
  message: string;
  variant: 'success' | 'error' | 'warning' | 'info';
  onClose: () => void;
  position: SnackbarPosition; // Accept the new position prop
}

const Snackbar: React.FC<SnackbarProps> = ({ message, variant, onClose, position }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    let timer: NodeJS.Timeout;

    if(variant !== "error"){
       timer = setTimeout(() => {
        setIsVisible(false);
        onClose();
      }, 5000);
    } 
    

    return () => clearTimeout(timer);
  }, [onClose]);

  const snackbarClasses = `snackbar snackbar-${variant} snackbar-${position} ${isVisible ? 'show' : ''}`;

  return (
    <div className={snackbarClasses} style={{display:'flex'}}>
      <span>{message}</span>
      {/* <button >&times;</button> */}
       <IconButton
          size="small"
          sx={{ justifyContent: "flex-end",color:"#fff" }}
          onClick={onClose}
        >
          <ClearOutlinedIcon fontSize='small' />
        </IconButton>
    </div>
  );
};

export default Snackbar;
